
if($('#qr-scanner').length > 0){

	const html5QrCode = new Html5Qrcode('qr-scanner')
	const config = { fps: 10, qrbox: { width: 250, height: 250 } }
	const $qr_scanner = $('#qr-scanner')
	var $message = $('.qr-scaner__message')
	
	const qrCodeSuccessCallback = (decodedText, decodedResult) => {
		
		html5QrCode.stop().then(() => {
			
			$qr_scanner.html('')
			$message = $('<div class="qr-scaner__message"></div>').appendTo($qr_scanner)
			
			alert(decodedText)
		})
		
	}
	
	function qrCodeStart(e){
		
		e.preventDefault()
		
		Html5Qrcode.getCameras().then(devices => {
			if (devices && devices.length) {
				
				let id = devices.length > 2 ? 1 : devices.length - 1
				
				html5QrCode.start(devices[id].id, config, qrCodeSuccessCallback)
				
			}else{
				html5QrCode.start({facingMode: "environment"}, config, qrCodeSuccessCallback)
				  .catch((err) => {
					  $message.text(err)
				  })
			}
		})
		  .catch((err) => {
			  $message.text(err)
		  })
	}
	
	$('.js-qr-scanner-start').click(qrCodeStart)
}